// Ported from horizontal-actions-dashboard/frontend/src/components/ProgressBar.tsx,
// translated to MUI LinearProgress.

import { Box, LinearProgress, Typography } from '@mui/material';

// pct is null or undefined when the backend has no figure (for example an older backend that
// does not send the newer fields yet). Both show "No data" rather than crashing the page.
export function TerminalsProgressBar({ pct, label }: { pct: number | null | undefined; label: string }) {
  const value = Math.max(0, Math.min(100, pct ?? 0));
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 140 }}>
      <Box sx={{ flex: 1 }}>
        <LinearProgress
          variant="determinate"
          value={value}
          aria-label={label}
          sx={{
            height: 8,
            borderRadius: 4,
            backgroundColor: '#e1e5e9',
            '& .MuiLinearProgress-bar': { backgroundColor: '#0067b3' },
          }}
        />
      </Box>
      <Typography variant="body2" sx={{ minWidth: 56, textAlign: 'right', color: '#5a6b7c' }}>
        {pct == null ? 'No data' : `${pct.toFixed(1)}%`}
      </Typography>
    </Box>
  );
}
